/* istanbul ignore file */
import { SpinnerWrapper } from '@commblades/commblades';

import StyledWrapper from './Wrapper.styled';
import { useAppSelector } from '../../../stories/hooks';
import { selectSpinnerDescription } from '../spinnerSelectors';
import useHideScrollBar from '../../../utils/useHideScrollBar';

const Spinner = () => {
    const description = useAppSelector(selectSpinnerDescription);

    useHideScrollBar();

    return (
        <div className="honeycomb honeycomb-utility">
            <StyledWrapper>
                <SpinnerWrapper id="full-screen-holding" text={description} />
            </StyledWrapper>
        </div>
    );
};

export default Spinner;
